import { gql } from 'src/__generated__'

export default gql(`
  mutation approvePhoto($id: Int!) {
    approvePhoto(id: $id) {
      id
    }
  }
`)
